import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#71F2F1",
      d: "M9.61 1.786 7.314 8.674H1l5.166 3.444-1.722 6.888 5.166-3.444 5.167 3.444-1.723-6.888 5.167-3.444h-6.315L9.61 1.786Z",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#035DD3",
      "stroke-linejoin": "round",
      "stroke-width": "1.634",
      d: "M9.61 1.786 7.314 8.674H1l5.166 3.444-1.722 6.888 5.166-3.444 5.167 3.444-1.723-6.888 5.167-3.444h-6.315L9.61 1.786Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "star"}) } }